import { render, staticRenderFns } from "./IconTarget.vue?vue&type=template&id=02c5aa98"
import script from "./IconTarget.vue?vue&type=script&lang=js"
export * from "./IconTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports